<div class='task-form' [formGroup]='taskForm()'>
  @for (parameter of task().inputParameters; track parameter.name) {
    <div class='task-form-inline-picker'>
      @if (parameter.type === 'URL') {
        <mat-form-field
          class='task-form-parameter-text'
          appearance='fill'>
          <mat-label>{{ parameter.displayName }}</mat-label>
          <input [attr.data-cy]="'task-parameter-' + parameter.displayName"
            matInput [formControlName]='parameter.name'
            type='url'
            [required]='true'>
        </mat-form-field>
      }
      @if (parameter.type === 'NUMBER') {
        <mat-form-field
          appearance='fill'>
          <mat-label>{{ parameter.displayName }}</mat-label>
          <input [attr.data-cy]="'task-parameter-' + parameter.displayName"
            matInput [formControlName]='parameter.name'
            type='number'
            [required]='true'>
        </mat-form-field>
      }
      @if (parameter.type === 'STRING') {
        <mat-form-field
          class='task-form-parameter-text'
          appearance='fill'>
          <mat-label>{{ parameter.displayName }}</mat-label>
          <input [attr.data-cy]="'task-parameter-' + parameter.displayName"
            matInput [formControlName]='parameter.name'
            type='text'
            [required]='true'>
        </mat-form-field>
      }
    </div>
  }
</div>
